// extracted by mini-css-extract-plugin
export default {"head_container":"Cart_head_container__gwaUl","title":"Cart_title__5hCQp","link":"Cart_link__6CZ-J"};